<template>
    <div class="indicator card" :class="!error ? 'indicator-ok' : 'indicator-error'">
        <div class="card-header">
            <span class="indicator-title float-left">Indicator #{{ indicatorNumber }}</span>
            <span class="indicator-actions float-right">
                <button class="btn btn-danger btn-sm ml-2" v-if="canDelete" v-on:click="clickDelete"><font-awesome-icon icon="times" /></button>
            </span>
        </div>
        <div class="card-body">
            <div v-if="error" class="alert alert-danger"><strong>Error:</strong> {{ error }}</div>
            <div class="input-group mb-3">
                <label class="col-sm-3 col-form-label">Indicator</label>

                <select v-model="internalIndicatorId" class="form-control">
                    <option value="">Select indicator</option>
                    <option v-for="(indicatorId, n) in scenarioIndicatorIds" :value="indicatorId" v-text="getIndicatorTitle(scenarioIndicatorsAssoc[indicatorId], n)" />
                </select>
            </div>
            <div class="input-group mb-3" v-if="internalIndicatorId">
                <label class="col-sm-3 col-form-label">Observation group</label>

                <select v-model="internalObservationGroupId" class="form-control">
                    <option value="">Select observation group</option>
                    <option v-for="(observationGroup, n) in indicatorObservationGroups" :value="observationGroup.id" v-text="getObservationGroupTitle(observationGroup, n)" />
                </select>
            </div>
            <div class="input-group mb-3" v-if="internalObservationGroupId">
                <label class="col-sm-3 col-form-label">Observations</label>
                <div class="col-sm-9">
                    <div class="row">
                        <observation-dependency-row
                                v-for="observation in indicatorObservations"

                                v-bind:value="observationDependencies && observationDependencies.hasOwnProperty(observation.id) ? observationDependencies[observation.id] : null"
                                v-on:input="onDependencyRowUpdated(observation.id, $event)"

                                :key="observation.id"
                                :observation="observation"
                                :allIndicators="allIndicators"
                                class="mb-3 full-width"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { $eBus } from '@/utils/eventBus';

    import ButtonRadioContainer from "@/components/common/ButtonRadioContainer";
    import ObservationDependencyRow from "@/components/admin/observation-group/ObservationDependencyRow";
    import { mapGetters } from 'vuex';
    import { getObservationTitle, getObservationGroupTitle, getIndicatorTitle } from "@/utils/admin/titleGenerator";
    import { validateScenarioIndicator} from "@/utils/admin/indicators/ExceptionValidator";

    export default {
        name: 'indicator-selector-single',
        components: {
            ObservationDependencyRow
        },
        props: {
            value: {
                type: Object,
                default() {
                    return {
                        indicatorId: null,
                        observationGroupId: null,
                        dependencies: {}
                    }
                }
            },
            allIndicators: {
                type: Array
            },
            indicatorNumber: {
                type: Number,
            },
            canDelete: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            if (this.value) {
                this.onValueUpdated(this.value);
            }
        },
        beforeMount() {
            $eBus.$on('forceValidate', this.validate);
        },
        beforeDestroy() {
            $eBus.$off('forceValidate', this.validate);
        },
        data() {
            return {
                useInternalWatchers: true,

                internalIndicatorId: '',
                internalObservationGroupId: '',

                indicatorObservationGroups: {},
                indicatorObservations: {},

                observationDependencies: {},

                internalData: null,
                error: null,
            };
        },
        methods: {
            validate() {
                try {
                    validateScenarioIndicator({
                        indicatorId: this.internalIndicatorId,
                        observationGroupId: this.internalObservationGroupId,
                        dependencies: this.observationDependencies,
                    }, this.allIndicators);

                    this.error = null;

                    console.log('single-selector.validate', true);
                } catch (error) {
                    this.error = error.message || error.toString();

                    console.log('single-selector.validate', this.error);

                    //throw error;
                }
            },
            onValueUpdated(value) {
                this.useInternalWatchers = false;

                this.internalIndicatorId = value.indicatorId || '';
                this.internalObservationGroupId = value.observationGroupId || '';
                this.observationDependencies = value.dependencies || {};

                this.validate();

                this.$nextTick(() => {
                    this.useInternalWatchers = true;
                });
            },
            getIndicatorTitle(indicator) {
                return getIndicatorTitle(indicator);
            },
            getObservationTitle(observation) {
                return getObservationTitle(observation);
            },
            getObservationGroupTitle(observationGroup) {
                return getObservationGroupTitle(observationGroup);
            },
            clickDelete() {
                this.$emit('delete', this.indicatorNumber)
            },
            clickAdd() {
                this.$emit('add')
            },
            updateValues() {
                let observationDependencies = {};

                for (let observationId in this.observationDependencies) {
                    let observationDependency = this.observationDependencies[observationId];

                    if (observationDependency.indicatorId || observationDependency.observationGroupId || observationDependency.observationId) {
                        observationDependencies[observationId] = this.observationDependencies[observationId];
                    }
                }

                let updateValues = {
                    indicatorId: parseInt(this.internalIndicatorId, 10) || null,
                    observationGroupId: parseInt(this.internalObservationGroupId, 10) || null,
                    dependencies: Object.keys(observationDependencies).length ? observationDependencies : null,
                };

                this.internalData = updateValues;

                this.$emit('input', updateValues);
            },
            onDependencyRowUpdated(observationId, value) {
                if (!this.observationDependencies) {
                    this.observationDependencies = {};
                }

                this.observationDependencies[observationId] = value;

                this.updateValues();
            }
        },
        watch: {
            value(value) {
                this.onValueUpdated(value);
            },

            internalIndicatorId(internalIndicatorId) {
                if (this.useInternalWatchers) {
                    this.indicatorObservations = {};
                    this.internalObservationGroupId = '';
                    this.indicatorObservations = {};
                    this.observationDependencies = {};
                }

                if (internalIndicatorId && this.activeIndicator) {
                    this.indicatorObservationGroups = this.activeIndicator.observationGroups;
                } else {
                    this.indicatorObservationGroups = {};
                }

                if (this.useInternalWatchers) {
                    this.updateValues();
                }
            },
            internalObservationGroupId(internalObservationGroupId) {
                if (this.useInternalWatchers) {
                    this.observationDependencies = {};
                }

                if (internalObservationGroupId && this.activeObservationGroup) {
                    this.indicatorObservations = this.activeObservationGroup.observations;
                } else {
                    this.indicatorObservations = {};
                }

                if (this.useInternalWatchers) {
                    this.updateValues();
                }
            }
        },
        computed: {
            ...mapGetters({
                'scenarioIndicators': 'getScenarioIndicators',
            }),
            scenarioIndicatorIds() {
                let indicatorsIds = [];

                for (let scenarioIndicator of this.scenarioIndicators) {
                    indicatorsIds.push(scenarioIndicator.id);
                }

                return indicatorsIds;
            },
            scenarioIndicatorsAssoc() {
                let indicatorsAssoc = {};

                for (let scenarioIndicator of this.scenarioIndicators) {
                    indicatorsAssoc[scenarioIndicator.id] = scenarioIndicator;
                }

                return indicatorsAssoc;
            },
            activeIndicator() {
                if (!this.scenarioIndicatorsAssoc.hasOwnProperty(this.internalIndicatorId)) {
                    return null;
                }

                return this.scenarioIndicatorsAssoc[this.internalIndicatorId];
            },
            activeObservationGroup() {
                if (!this.activeIndicator) {
                    return null;
                }

                if (!this.internalObservationGroupId) {
                    return null;
                }

                return this.activeIndicator.observationGroups[this.internalObservationGroupId];
            },
        }
    }
</script>

<style lang="scss" scoped>
    .indicator-title {
        line-height: 38px;
    }

    .full-width {
        width: 100%;
    }

    .indicator {
        &.indicator-ok {

        }

        &.indicator-error {
            background: #ffbcbcbc;
        }
    }
</style>
